export const isCookieSet = (cookieName: string): boolean => {
    if (typeof document !== 'undefined') {
        const cookies = document.cookie.split(';')
        return cookies.some((cookie) =>
            cookie.trim().startsWith(`${cookieName}=`)
        )
    }
    return false
}
